import { useEffect, useState } from 'react'

import { DropResult } from 'react-beautiful-dnd'

import { ChecklistItem } from '@/types/unlock'
import { listReorder } from '@/utils/ListReorder'

export const useTaskManagement = (activeGroupItems: ChecklistItem[]) => {
  const [tasks, setTasks] = useState<ChecklistItem[]>([])

  useEffect(() => {
    setTasks(activeGroupItems)
  }, [activeGroupItems])

  const handleDragEnd = (updateSequence: any) => async (result: DropResult) => {
    if (!result.destination || result.destination.index === result.source.index) {
      return
    }

    const taskChanged = tasks[result.source.index]
    await updateSequence({
      uuid_from: taskChanged.uuid,
      destination_index: result.destination.index,
    })

    setTasks(listReorder(tasks, result.source.index, result.destination.index))
  }

  return { tasks, handleDragEnd }
}
